import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2, Star, Info } from "lucide-react";

export const Section = ({ title, description, children, "data-testid": tid }) => (
  <div className="bg-card border border-border rounded-xl p-6 space-y-5" data-testid={tid}>
    <div>
      <div className="font-display font-semibold text-lg">{title}</div>
      {description && <div className="text-sm text-muted-foreground mt-0.5">{description}</div>}
    </div>
    {children}
  </div>
);

export const Hint = ({ children }) => (
  <p className="text-xs text-muted-foreground flex items-start gap-1.5"><Info className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {children}</p>
);

export const MethodRow = ({ primary, secondary, status, isDefault, onDefault, onDelete, onVerify, testPrefix }) => {
  const statusClass = status === "Verified" ? "text-emerald-700 bg-emerald-100 dark:bg-emerald-900/40 dark:text-emerald-300" : status === "Pending" ? "text-amber-700 bg-amber-100 dark:bg-amber-900/40 dark:text-amber-300" : "text-slate-700 bg-slate-100 dark:bg-slate-800 dark:text-slate-300";
  return (
    <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3 border border-border rounded-lg p-3" data-testid={`${testPrefix}-row`}>
      <div className="min-w-0">
        <div className="font-medium flex items-center gap-2 flex-wrap">
          {primary}
          {isDefault && <span className="inline-flex items-center gap-1 text-[10px] font-bold tracking-widest text-primary bg-primary/10 px-1.5 py-0.5 rounded"><Star className="w-3 h-3" /> DEFAULT</span>}
        </div>
        <div className="text-xs text-muted-foreground">{secondary}</div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full ${statusClass}`}>{status}</span>
        {onVerify && <Button size="sm" variant="outline" onClick={onVerify} data-testid={`${testPrefix}-verify-btn`}>Verify</Button>}
        {!isDefault && <Button size="sm" variant="outline" onClick={onDefault} data-testid={`${testPrefix}-default-btn`}>Set default</Button>}
        <Button size="sm" variant="ghost" onClick={onDelete} data-testid={`${testPrefix}-delete-btn`}><Trash2 className="w-4 h-4" /></Button>
      </div>
    </div>
  );
};
